<div [formGroup]="formGroup">
  <mat-form-field class="w-100">
    <mat-label>{{ label }}</mat-label>
    <input type="text" autocompleteOff matInput formControlName="item" autocomplete="new-password" (keyup)="postalCodeChanged()" />
    @if (maxLength) {
      <mat-hint align="end">{{ itemControl.value?.length }} / {{ maxLength }}</mat-hint>
    }
    @if (itemControl.hasError('pattern')) {
      <mat-error>
        {{ 'common.invalid' | translate }} {{ 'portal.settings.company.postal-code' | translate }}
      </mat-error>
    }
    @if (itemControl.hasError('blocked')) {
      <mat-error>
        {{'common.only-swiss-zips-allowed' | translate}}
      </mat-error>
    }
    @if (itemControl.hasError('required')) {
      <mat-error>
        {{ 'Public.ContactData.Validation.Required' | translate }}
      </mat-error>
    }
    @if (itemControl.hasError('forbiddenCharacters')) {
      <mat-error>
        {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
      </mat-error>
    }
    @if (itemControl.hasError('forbiddenLocationCharacters')) {
      <mat-error>
        {{ 'Common.Validation.HasForbiddenLocationCharacters' | translate }}
      </mat-error>
    }
  </mat-form-field>
</div>